import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import {useTranslation} from 'react-i18next';
import {SUPPORTED_FISH_SPECIES} from 'appConstants';
import SpeciesChip from 'components/Generic/SpeciesChipts';
import {type HarvestDemandPutSpeciesEnum} from 'client';
import TextField from '@mui/material/TextField';

const ANY_SPECIES_VALUE = 'any';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type SpeciesSelectorProps = {
  species?: string | null;
  setSpecies: (value?: HarvestDemandPutSpeciesEnum) => void;
  none?: boolean;
} & React.ComponentProps<typeof TextField>;

export function SpeciesSelector({species, setSpecies, none, ...other}: SpeciesSelectorProps) {
  const {t} = useTranslation('common');

  const speciesList = none ? [...SUPPORTED_FISH_SPECIES, ANY_SPECIES_VALUE] : SUPPORTED_FISH_SPECIES;
  return (
    <TextField
      select
      label={t('species')}
      value={species ?? ''}
      slotProps={{
        select: {
          renderValue: (selected) => (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
              {selected && selected !== ANY_SPECIES_VALUE ? <SpeciesChip species={selected as string} /> : null}
            </Box>
          ),
          MenuProps,
        },
      }}
      onChange={({target: {value}}) => {
        if (value === ANY_SPECIES_VALUE) {
          setSpecies(undefined);
        } else if (value) {
          setSpecies(value as HarvestDemandPutSpeciesEnum);
        }
      }}
      data-testid="species-control"
      {...other}
    >
      {speciesList.map((name) => (
        <MenuItem key={name} value={name} data-testid={`species-${name}`}>
          {t(name)}
        </MenuItem>
      ))}
    </TextField>
  );
}
